import Table2 from "./Table2";

export default Table2;
